import React from 'react'

export const Logo = () => {
  return (
    <div
      className='bg-[#FFF1B8] rounded-tl-lg rounded-bl-lg rounded-br-lg h-[43.55px] w-[43.55px] p-2 my-auto hidden md:block'
      style={{
        boxShadow: '3.40214px 0px 20.4128px 1.37614px rgba(255, 210, 32, 0.19)',
      }}
    >
      <div
        className='bg-[#FFCC00] h-[27.87px] w-[27px] rounded-tl-sm rounded-bl-sm rounded-br-sm'
        style={{
          boxShadow:
            '3.40214px 0px 20.4128px 1.37614px rgba(255, 210, 32, 0.19)',
        }}
      ></div>
    </div>
  )
}
